import { WhatsappCard } from '@components/WhatsappCard';
import styles from '../DemoPage.module.scss';
import { SectionHeader } from './shared';

export const WhatsappCardSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="WhatsApp Card"
      description="A card component for displaying WhatsApp contact information with action buttons. Supports two states: not contacted (with 'Reach Out' action) and contacted (with 'Open Chat' action)."
      figmaNodeId="790-9120"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Not Contacted State</h3>
      <p className={styles.hint}>
        Grey background with "Reach Out" button. Hover to see subtle shadow.
      </p>
      <div className={styles.whatsappCardContainer}>
        <WhatsappCard
          name="+961 71 111 000"
          subtitle="Whatsapp"
          contacted={false}
          onAction={() => {}}
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Contacted State</h3>
      <p className={styles.hint}>
        White background with border and "Open Chat" button. Hover to see subtle shadow.
      </p>
      <div className={styles.whatsappCardContainer}>
        <WhatsappCard
          name="+961 71 111 000"
          subtitle="Whatsapp"
          contacted={true}
          onAction={() => {}}
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Different Phone Numbers</h3>
      <div className={styles.whatsappCardGrid}>
        <WhatsappCard name="+1 (555) 123-4567" subtitle="WhatsApp Business" contacted={false} />
        <WhatsappCard name="+44 20 7946 0958" subtitle="WhatsApp" contacted={true} />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Props</h3>
      <div className={styles.propsTable}>
        <div className={styles.propRow}>
          <code>name</code>
          <span>Contact name or phone number (required)</span>
        </div>
        <div className={styles.propRow}>
          <code>subtitle</code>
          <span>Subtitle text, defaults to "Whatsapp"</span>
        </div>
        <div className={styles.propRow}>
          <code>contacted</code>
          <span>Whether the contact has been contacted (changes appearance and action)</span>
        </div>
        <div className={styles.propRow}>
          <code>onAction</code>
          <span>Click handler for the action button</span>
        </div>
      </div>
    </div>
  </section>
);
